import { ErrorBoundary } from "react-error-boundary";
import "react-toastify/dist/ReactToastify.css";

import "../styles/globals.css";
import "../styles/nprogress.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppProps } from "next/app";
import Router from "next/router";
import NProgress from "nprogress";
import { useEffect } from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import { useDarkModeSync } from "../components/reuseables/theme.comp";
import init, { useSyncSessionAndCookies } from "../core/init.core";
import { GlobalStateProvider } from "../states/root.state";
import store from "../store";
import Fallback from "../components/fallback.comp";
import BlockRetailUser from "../components/blockRetailUser.comp";
import { logBoundaryError } from "../core/log.core";

Router.events.on("routeChangeStart", () => NProgress.start());
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

export default function MyApp({ Component, pageProps }: AppProps) {
  useDarkModeSync();
  useSyncSessionAndCookies();

  useEffect(() => {
    init();
  }, []);

  return (
    <ErrorBoundary FallbackComponent={Fallback} onError={logBoundaryError}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <GlobalStateProvider>
            <BlockRetailUser />
            <Component {...pageProps} />
            <ToastContainer />
          </GlobalStateProvider>
        </Provider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
